// 1_utils/shoptet_overrides.js
// Deliberately no-ops Shoptet's GLOBAL moveFilters() so the platform never moves
// the category filters around (our own layout code handles them). Must be assigned
// to window: in an esbuild bundle a bare `function moveFilters() {}` would be
// module-scoped and would no longer shadow the Shoptet global.

window.moveFilters = function () {};
